var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91 2.0498C2.40742 2.0498 2 2.45723 2 2.9598V20.1398C2 20.6424 2.40742 21.0498 2.91 21.0498H12.45C12.9526 21.0498 13.36 20.6424 13.36 20.1398V2.9598C13.36 2.45723 12.9526 2.0498 12.45 2.0498H2.91ZM0 2.9598C0 1.35266 1.30285 0.0498047 2.91 0.0498047H12.45C14.0571 0.0498047 15.36 1.35266 15.36 2.9598V20.1398C15.36 21.747 14.0571 23.0498 12.45 23.0498H2.91C1.30285 23.0498 0 21.747 0 20.1398V2.9598Z",
    fill: "#7F5FEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88032 0H11.4763L11.5363 0.93609C11.5534 1.20282 11.5151 1.47021 11.424 1.72148C11.3329 1.97275 11.1908 2.20247 11.0067 2.39625C10.8227 2.59003 10.6005 2.74368 10.3542 2.84756C10.1103 2.95047 9.84785 3.00234 9.58313 3H5.77353C5.50881 3.00234 5.24638 2.95047 5.00241 2.84756C4.75614 2.74368 4.534 2.59003 4.34991 2.39625C4.16582 2.20247 4.02376 1.97275 3.93263 1.72148C3.84151 1.47021 3.80329 1.20282 3.82037 0.93609L3.88032 0Z",
    fill: "#7F5FEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63047 20.1895H6.73047V18.1895H8.63047V20.1895Z",
    fill: "#7F5FEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.47a0491f4b5c6c018b92e1700ae33629.svg";
export { ForwardRef as ReactComponent };